import { defineMessages } from 'react-intl';

export default defineMessages({
    wizardFnolSummaryPageRepairDetailsNoRepairEstimate: {
        id: 'anonymous.wizard.fnol.pages.summary.Estimated Repair Cost: ',
        defaultMessage: 'Estimated repair cost: '
    }
});
